module.exports = __webpack_public_path__ + "static/media/slide-1-image.293e3db3.svg";